export default () => {
    const staticBaseUrl = process.env.VUE_APP_STATIC_BASE_URL;
    return [
        {
            name:
                'Diga o que você precisa contratar e se precisar, tenha o auxílio do nosso time de Engenharia sem pagar nada por isso',
            image: `${staticBaseUrl}/landing-2020/process-1.svg`
        },
        {
            name: 'Nossa plataforma processa sua cotação e encontra os melhores fornecedores',
            image: `${staticBaseUrl}/landing-2020/process-2.svg`
        },
        {
            name: 'Compare as melhores propostas e feche sua contratação',
            image: `${staticBaseUrl}/landing-2020/process-3.svg`
        }
    ];
};
